import { Component, OnInit, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { WorkflowService } from './service/workflow/workflow.service';
import { WidgetContextData, WorkflowWidgetState } from './widget-context.type';
import { WidgetStateService } from './widget/widget-state.service';
import { WorkflowPageNavigationService } from './service/workflow-page-navigation/workflow-page-navigation.service';
import { WidgetContextDataShared } from './widget/widget-context-data.shared';
import { FlowInstance } from './class/flow.service';
import { PageInstance } from './class/page.service';

@Component({
  selector: 'cudc-dynamic-workflow',
  templateUrl: './dynamic-workflow.component.html',
  styleUrls: ['./dynamic-workflow.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicWorkflowComponent implements OnInit {
  @Input() loanManagement = false;
  @Input()
  public get widgetContext(): WidgetContextData {
    return WidgetContextDataShared.widgetContext;
  }
  public set widgetContext(context: WidgetContextData) {
    WidgetContextDataShared.widgetContext = context;
  }

  @Output()
  public widgetStateChange: EventEmitter<WorkflowWidgetState> = WidgetStateService.widgetStateChange$;
  public get widgetState(): WorkflowWidgetState {
    return this.widgetStateService.currentState;
  }

  constructor(
    private readonly widgetStateService: WidgetStateService,
    private readonly workflowPageNavigationService: WorkflowPageNavigationService,
    private readonly workflowService: WorkflowService
  ) {}

  flow: FlowInstance;
  currentFlow: FlowInstance;
  public ngOnInit() {
    this.flow = this.workflowService.getFlowById(this.widgetContext.config.flowId);
    this.currentFlow = this.workflowService.currentFlow;

    // Why is this always throwing this warning???
    // Added a currentFlow.id, seems to have the value there
    if (!this.flow && !this.currentFlow?.id) {
      console.warn('Warning: No flow has been selected!');
    }
  }

  gotoFLow() {
    if (this.flow) {
      this.workflowPageNavigationService.goToFirstPageOfFlow(this.flow.id);
    }
  }

  gotoPageOfFLow(flow: FlowInstance, page: PageInstance) {
    this.workflowPageNavigationService.goToPageOfFlow(flow.id, page.id, page.pageIterationId);
  }
}
